// extracted by mini-css-extract-plugin
export var destinfowrapper = "destinfo-module--destinfowrapper--54d6d";
export var infocircle = "destinfo-module--infocircle--1d5a2";